import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GerenciadorPrecos } from '../../../@types/GerenciadorPrecos';
import { RootState } from '../../../@types/RootState';

type Keys = GerenciadorPrecos.FilterKeys;

export type SegmentoValue = {
  type: string;
  value: string;
};

export type FiltersValueState = Partial<
  Record<Exclude<Keys, 'segmentos' | 'priceStatus'>, string[]> & Record<'segmentos' | 'priceStatus', SegmentoValue[]> & Record<'storeTypes', string[]>
>;

const initialFiltersValueState: FiltersValueState = {
  storeTypes: [],
  responsible: [],
};

const slice = createSlice({
  name: 'ipa.filters.value',
  initialState: initialFiltersValueState,
  reducers: {
    SET_FILTERS_VALUE: (_, action: PayloadAction<FiltersValueState>) => {
      return action.payload;
    },
    SET_FILTERS_VALUE_BY_KEY: (
      state,
      {
        payload,
      }: PayloadAction<{
        key: Keys;
        value: string[];
      }>,
    ) => {
      return {
        ...state,
        [payload.key]: payload.value,
      };
    },
    UPDATE_FILTERS_VALUE_BY_KEY: (
      state,
      {
        payload,
      }: PayloadAction<{
        key: Keys;
        value: string[];
      }>,
    ) => {
      return {
        ...state,
        [payload.key]: [...(state[payload.key] ?? []), ...payload.value],
      };
    },
    RESET_FILTERS_VALUE: () => {
      return initialFiltersValueState;
    },
    RESET_FILTERS_VALUE_BY_KEY: (
      state,
      {
        payload,
      }: PayloadAction<{
        key: Keys;
      }>,
    ) => {
      return {
        ...state,
        [payload.key]: [],
      };
    },
    ADD_SEGMENT_VALUE: (state, { payload }: PayloadAction<SegmentoValue[]>) => {
      return {
        ...state,
        segmentos: [...(state.segmentos ?? []), ...payload],
      };
    },
    SET_PRICE_STATUS: (state, { payload }: PayloadAction<SegmentoValue[]>) => {
      state.priceStatus = payload;
    },
  },
});

const selectorFiltersValues = (state: RootState) => {
  return state.gerenciadorPrecosReducer.filters.values;
};

const {
  SET_FILTERS_VALUE,
  SET_PRICE_STATUS,
  SET_FILTERS_VALUE_BY_KEY,
  UPDATE_FILTERS_VALUE_BY_KEY,
  RESET_FILTERS_VALUE,
  RESET_FILTERS_VALUE_BY_KEY,
  ADD_SEGMENT_VALUE,
} = slice.actions;

export {
  ADD_SEGMENT_VALUE,
  RESET_FILTERS_VALUE,
  RESET_FILTERS_VALUE_BY_KEY,
  SET_FILTERS_VALUE,
  SET_FILTERS_VALUE_BY_KEY,
  SET_PRICE_STATUS,
  UPDATE_FILTERS_VALUE_BY_KEY,
  initialFiltersValueState,
  selectorFiltersValues,
};

export default slice.reducer;
